import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BillingSummary } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class BillingService extends UzurvRestService {
  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domsanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domsanitizer);
  }

  getBillingSummaryByReservationId(reservationId: number): Observable<BillingSummary> {
    return this.get('reservations/' + reservationId + '/billingSummary').pipe(map(response => Deserialize(response, BillingSummary)));
  }
}
